import { useReactiveVar } from "@apollo/client";

import { currentUserVar, leftSidePanelVar } from "@cache/cache";
import Avatar from "@components/avatar/avatar";
import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";
import Link from "@components/link/link";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";
import { assertEdgesNonNull, getUrl } from "@helpers/helpers";

const SidebarReportsExpanded = () => {
  const leftSidePanel = useReactiveVar(leftSidePanelVar);
  const reportsPanelOpen = leftSidePanel === "reports";
  const currentUser = currentUserVar();
  const directReports = assertEdgesNonNull(currentUser.directReports);

  if (!reportsPanelOpen) {
    return null;
  }

  return (
    <div className="bg-sidenav-back flex-1 flex flex-col overflow-hidden border-gray-200">
      <div className="pl-3 pr-3 pt-4 pb-2">
        <Button
          theme="blueText"
          size={ButtonSize.medium}
          onClick={() => leftSidePanelVar(false)}
          className="text-[13px]"
        >
          <TopicflowIcon type="arrowLeft" className="h-3 w-3" />
          Back to navigation
        </Button>
      </div>
      <div className="px-5 pb-2">
        <div className="text-gray-500 text-xs">
          Reports ({directReports.length})
        </div>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-hidden px-3 pb-4">
        <div className="flex flex-col gap-0.5">
          {directReports.map((user: any) => {
            const profileUrl = getUrl({ userId: user.id });
            return (
              <Link
                key={user.id}
                to={profileUrl}
                className={classNames(
                  "flex items-center gap-2 px-2 py-1 rounded hover:bg-nav-item-active",
                  window.location.href.startsWith(
                    `${window.location.origin}${profileUrl}`,
                  )
                    ? "bg-nav-item-active"
                    : "",
                )}
              >
                <Avatar user={user} size="4" showTooltip={false} />
                <span className="text-gray-800 text-sm font-normal truncate">
                  {user.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SidebarReportsExpanded;
